module.exports = __webpack_public_path__ + "img/invi-2.cebb1188.png";